// extracted by mini-css-extract-plugin
module.exports = {"main":"SaveAs_main__1OvUe","actions":"SaveAs_actions__VXLYG"};